export default {
    primary: '#2089dc',
    grey3: '#86939e',
  };